module.exports = __webpack_public_path__ + "img/dice-5-fill.f029dfc9.svg";